if (
  typeof Array !== undefined
  && Array.prototype
  && !Array.prototype.matches
) {
  Object.defineProperty(Array.prototype, 'matches', {
    value({
      includesAll = [],
      includesAny = [],
      excludesAll = [],
      excludesAny = [],
    } = {}) {
      if (!Array.isArray(includesAll)) includesAll = [includesAll];
      if (!Array.isArray(includesAny)) includesAny = [includesAny];
      if (!Array.isArray(excludesAll)) excludesAll = [excludesAll];
      if (!Array.isArray(excludesAny)) excludesAny = [excludesAny];
      let result = true;
      if (includesAll.length) {
        for (const include of includesAll.flat(Number.MAX_SAFE_INTEGER)) {
          if (!this.includes(include)) result = false;
        }
      }
      if (includesAny.length) {
        if (!this.some(value => includesAny.includes(value))) result = false;
      }
      if (excludesAll.length) {
        for (const exclude of excludesAll.flat(Number.MAX_SAFE_INTEGER)) {
          if (this.includes(exclude)) result = false;
        }
      }
      if (excludesAny.length) {
        if (this.some(value => excludesAny.includes(value))) result = false;
      }
      return result;
    }
  });
}